import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { LanguageService } from '../../../services/language.service';

/** Compact EL/EN toggle. Shows the language you would switch to. */
@Component({
  selector: 'app-language-switcher',
  standalone: true,
  imports: [TranslatePipe],
  template: `
    <button
      type="button"
      class="lang-switch"
      (click)="lang.toggle()"
      [attr.aria-label]="'lang.switchTo' | translate"
      [title]="'lang.switchTo' | translate"
    >
      {{ lang.lang() === 'el' ? 'EN' : 'ΕΛ' }}
    </button>
  `,
  styles: [
    `
      .lang-switch {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 38px;
        height: 32px;
        padding: 0 10px;
        border: 1px solid var(--ap-hairline, #e5e5e5);
        border-radius: 999px;
        background: transparent;
        font-family: var(--ap-sans, inherit);
        font-size: 13px;
        font-weight: 600;
        color: var(--ap-ink-2, #424245);
        cursor: pointer;
        transition: border-color 0.15s ease, color 0.15s ease;
      }
      .lang-switch:hover {
        border-color: var(--ap-ink-3, #86868b);
        color: var(--ap-ink, #1d1d1f);
      }
    `,
  ],
})
export class LanguageSwitcherComponent {
  readonly lang = inject(LanguageService);
}
